module.exports = __webpack_public_path__ + "img/MGH-Nakasu-8.6464059f.jpg";